angular
  .module("AccountingBoxApp")
  .controller("TransactionCtrl", function(
    $scope,
    $rootScope,
    LoopBackAuth,
    $timeout,
    $state,
    $stateParams,
    Attachment
  ) {
    $scope.message = "Hello";
    var vm = this;
    vm.attachmentId = $state.params.id;

    $(document).keyup(function(e) {
      if (e.key === "Escape") { // escape key maps to keycode `27`
        $scope.close();
        console.log('escape')
      }
    });

    $scope.$on('$destroy', function(){
      $(document).unbind("keyup");
    })

    vm.token = LoopBackAuth.accessTokenId;
    var currentRoute;
    var uploads;

    $scope.animationsEnabled = true;

    $scope.optionsDate = {
      language: "nl",
      todayHighlight: true,
      format: "dd-mm-yyyy",
      autoclose: true
    };

    $scope.options = {
      language: "nl",
      todayHighlight: true,
      format: "dd-mm-yyyy",
      autoclose: true
    };
    $scope.optionsAccounts = {
      minLength: 2
    };

    function getUploads(cb) {
      uploads = Attachment.find(
        {
          filter: {
            where: {
              transactionId: ""
            },
            order: "created DESC"
          }
        },
        function(uploads) {
          vm.uploads = uploads;
          if (cb) {
            cb();
          }
        }
      );
    }

    $scope.openNextUpload = function(e, data) {
      getUploads(function() {
        let index = $rootScope.uploadIndex || 0;
        if (vm.uploads.length > index) {
          let upload = vm.uploads[index];
          let processingScreen = "purchases";
          if (
            upload.transactionProposal &&
            upload.transactionProposal.transactionType
          ) {
            if (upload.transactionProposal.transactionType === "Sale") {
              processingScreen = "sales";
            } else if (
              upload.transactionProposal.transactionType === "JournalEntry"
            ) {
              processingScreen = "journalEntries";
            }
          }
          $state.go("app.company.new." + processingScreen, {
            id: upload.id,
            attachment: upload
          });
        } else {
          $state.go("app.company.inbox");
        }
      });
    };

    $scope.close = function() {
      $scope.$broadcast("close");
    };
    $scope.isActive = function(route) {
      if (
        $state.current.name === "app.company.new.sales" ||
        $state.current.name === "app.company.edit.sales"
      ) {
        currentRoute = "sales";
      } else if (
        $state.current.name === "app.company.new.purchases" ||
        $state.current.name === "app.company.edit.purchases"
      ) {
        currentRoute = "purchases";
      } else if (
        $state.current.name === "app.company.new.journalEntries" ||
        $state.current.name === "app.company.edit.journalEntries"
      ) {
        currentRoute = "journalEntries";
      }
      return route === currentRoute;
    };
    $scope.isNew = function() {
      if ($state.current.name.indexOf("app.company.new") > -1) {
        return true;
      } else {
        return false;
      }
    };
    $scope.showMenu = function(route) {
      var to = "app.company.edit." + route;
      if ($state.current.name.indexOf("app.company.new") > -1) {
        return true;
      } else if ($state.current.name === to) {
        return true;
      } else {
        return false;
      }
    };
    $scope.removeAttachment = async function() {
      $("#removeAttachmentModal").modal("hide");
      try {
        await Attachment.deleteById({
          id: $scope.transaction.attachmentId
        }).$promise;
        $('.modal-backdrop.fade.in').remove();
        $scope.close();
      }catch (e) {
        window.swal("Verwijderen mislukt", e.data?.error?.message || e.message, "error");
        console.log('deleted attachment error',e)
      }
    };
    $scope.switchEditScreen = function(to) {
      var toName;
      var toId;
      if (!$scope.transaction.id) {
        toName = "app.company.new." + to;
        toId = $scope.transaction.attachmentId;

        if ($state.current.name !== toName) {
          $state.go(toName, {
            id: toId
          });
          console.log(to);
          console.log(toName);
          console.log(toId);
        }
      }
    };

    $scope.openNewContactModal = function() {
      $scope.openContactModal();
      $timeout(function() {
        var $e = angular.element("#companyAutocompleteInput");
        $e.click();
      }, 0);
    };
    $scope.closeContactModal = function() {
      $("#contactModal").modal("hide");
    };

    $scope.openContactModal = function() {
      $("#contactModal").modal({ backdrop: "static", keyboard: false });
      $("#contactModal").on("hide.bs.modal", function() {
        $timeout(function() {
          $("#fileContainer").animate({ width: originalWidth }, 400);
          $(".transaction-header .nav-tabs").animate({ opacity: 1 }, 200);
          $(".edit-container .transaction-edit-form").animate(
            { opacity: 1 },
            200
          );
          $("#contactModal").unbind("hide.bs.modal");
        }, 0);
      });

      $(".modal-backdrop.fade.in").css({ display: "none" });
      var w =
        $("#fileContainer")
          .parent()
          .width() - 820;
      var originalWidth = $("#fileContainer").width();
      console.log("width:", w);
      $timeout(function() {
        $("#fileContainer").animate({ width: w }, 400);
        $(".transaction-header .nav-tabs").animate({ opacity: 0 }, 200);
        $(".edit-container .transaction-edit-form").animate(
          { opacity: 0 },
          200
        );
      }, 0);
    };
  });
